import { z } from 'zod'
import { TFunction } from 'i18next'
import { TariffStatusType } from 'src/Libs/e-mobility/shared/models/types'

type TariffRef = { value: string; tariffStatus: TariffStatusType }

/** return type of zod.refine() is too complex and redundant to be manually specified here, let TypeScript infer the type on its own */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/explicit-function-return-type
export const createAssignTariffSchema = (t: TFunction, initialTariffs: TariffRef[], selectableTariffs: TariffRef[]) => {
  const initiallyExpired = new Set(initialTariffs.filter(t => t.tariffStatus === TariffStatusType.expired).map(t => t.value))

  const expiredSelectable = new Set(selectableTariffs.filter(t => t.tariffStatus === TariffStatusType.expired).map(t => t.value))

  const tariffSchema = z
    .object({
      value: z.string().min(1, t('emobility.wallbox.assign-tariff-required')),
    })
    .refine(data => !initiallyExpired.has(data.value), {
      path: ['value'],
      message: t('emobility.wallbox.expired-tariff-already-assigned'),
    })
    .refine(data => !expiredSelectable.has(data.value), {
      path: ['value'],
      message: t('emobility.wallbox.can-not-assign-expired-tariff'),
    })

  return z.object({
    tariffs: z.array(tariffSchema),
  })
}

export type AssignTariffFormData = z.infer<ReturnType<typeof createAssignTariffSchema>>
